import React, { useEffect, useState } from "react";
import logo from "../Images/Maersk_Logo_RGB.png";
import Ionis from "../Images/test.jpeg";
import { McTab } from "@maersk-global/mds-react-wrapper/components-core/mc-tab";
import { McTabBar } from '@maersk-global/mds-react-wrapper/components-core/mc-tab-bar';
import { useMsal } from "@azure/msal-react";
import { loginRequest, apiUrl } from "../authconfig";
import { callMsGraph } from "../graph";
import { McIcon } from "@maersk-global/mds-react-wrapper/components-core/mc-icon";
import { McButton } from "@maersk-global/mds-react-wrapper/components-core/mc-button";
import { useNavigate } from 'react-router-dom';
import apiClient from "../api/apiClient";
import HoverTip from "@mui/material/Tooltip";
import { McNotification } from "@maersk-global/mds-react-wrapper/components-core/mc-notification";
import { useDispatch, useSelector } from 'react-redux';
import { setProfileData, setProfileLoading, setProfileError, selectProfileRefetchRequested } from '../redux/profileSlice';
import { checkUserIsAdmin } from '../api/adminUserCheck';

const PENDING_COUNT_STORAGE_KEY = "dealtoreal_user_access_pending_count";
const DEFAULT_PENDING_COUNT = 3;

const Header = ({currentIndex}) => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState({ name: "", photo: "",mail:"" });
  const [myprofiledata, setMyProfileData] = useState({});
  const [isUserAccessAllowed, setIsUserAccessAllowed] = useState(false);

  const [pendingAccessCount, setPendingAccessCount] = useState(() => {
    const raw = sessionStorage.getItem(PENDING_COUNT_STORAGE_KEY);
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : DEFAULT_PENDING_COUNT;
  });
  const profileStatus = useSelector((state) => state.profile.status);
  const profileRefetchRequested = useSelector(selectProfileRefetchRequested);
  const dispatch = useDispatch();

useEffect(() => {
  const updateFromStorage = () => {
    const raw = sessionStorage.getItem(PENDING_COUNT_STORAGE_KEY);
    const parsed = Number(raw);
    setPendingAccessCount(Number.isFinite(parsed) ? parsed : DEFAULT_PENDING_COUNT);
  };

  const onPendingCountEvent = (event) => {
    const count = Number(event?.detail?.count);
    if (Number.isFinite(count)) {
      setPendingAccessCount(count);
      return;
    }
    updateFromStorage();
  };

  updateFromStorage();
  window.addEventListener("storage", updateFromStorage);
  window.addEventListener("dtr-user-access-pending-count", onPendingCountEvent);

  return () => {
    window.removeEventListener("storage", updateFromStorage);
    window.removeEventListener("dtr-user-access-pending-count", onPendingCountEvent);
  };
}, []);


useEffect(() => {
  if (profileRefetchRequested) {
    graphData.mail && fetchMyData();
  }
}, [profileRefetchRequested]);
 
useEffect(() => {
  graphData?.mail && fetchMyData();
}, [graphData.mail ]);

const fetchMyData = async () => {


  try {
    dispatch(setProfileLoading());

    const userPrincipalName = (graphData?.mail || '').toLowerCase();
    const url = `${apiUrl}/api/point-data/getByEmail/${userPrincipalName}`;
    const response = await apiClient.get(url);
    setMyProfileData(response.data);
    dispatch(setProfileData(response.data));
    console.log('response', response.data);
  } catch (error) {
    console.log('error', error);
    dispatch(setProfileError(error?.message || 'Failed to fetch profile data'));
  }

}

  useEffect(() => {
    if (accounts.length > 0) {
      // Silently acquire an access token to call Microsoft Graph
      instance
        .acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        })
        .then((response) => {
          // Fetch user profile data including name and photo
          callMsGraph(response.accessToken).then((response) => {
            setGraphData({
              name: response.displayName, // User's name
              photo: response.photo, // User's profile photo URL
              mail: response.mail,
            });
            console.log("response123", response);
            sessionStorage.setItem("user", JSON.stringify(response));
            // fetchMyData();
            apiClient
            .post(`${apiUrl}/api/assign-users`, [{
              "userPrincipalName": response.mail.toLowerCase() || "",
              "displayName": response.displayName.toLowerCase() || "",
              "objectType": "User",
              "userType": "Member",
              "isUser": true,
              "isGroup": false,
              "isGuest": false
            }
            ]
          
            )
            .then((response) => {

            })
            .catch((error) => {
              console.error("Error saving user data: ", error);
            });

          });
        })
        .catch((error) => {
          console.error("Error fetching MS Graph data: ", error);
        });
    }
  }, [accounts, instance]);

  const logoStyles = {
    height: "50px",
    paddingLeft:'10px',
    marginTop: "-5px",
  };

  const logoStyles2 = {
    height: "35px",
   
  };

  const userPhotoStyles = {
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    marginRight: "0px",
  };

  console.log("callMsGraph", graphData);

  useEffect(() => {
    const mail = (graphData?.mail || "").toLowerCase().trim();
    if (!mail) {
      setIsUserAccessAllowed(false);
      return undefined;
    }
    let cancelled = false;
    checkUserIsAdmin(mail).then(({ isAdmin }) => {
      if (!cancelled) setIsUserAccessAllowed(isAdmin);
    });
    return () => {
      cancelled = true;
    };
  }, [graphData?.mail]);

  const navigate = useNavigate();

  const handleTabChange = (index,path) =>{
   
  navigate(path)

  }

  return (
    <div>
      <div
        className="HeaderStyle"
        style={{
          background: "#fff",
          color: "black",
          display: "flex",
          height: "50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={logo} alt="Company Logo" style={logoStyles} />
        </div>
        <div style={{display:'flex',alignItems: 'center'}}>
          <McTabBar currentindex={currentIndex}>
            <McTab slot="tab" label="Project Portfolio Overview" icon="house" onClick={() =>handleTabChange(0,'/')}></McTab>
            <McTab slot="tab" label="Project queue" icon="briefcase" onClick={() => handleTabChange(1,'/opportunities')}></McTab>
          </McTabBar>
        </div>
       
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          {isUserAccessAllowed && (
          <div style={{ position: 'relative' }}>
            <McButton
              variant="plain"
              appearance="neutral"
              label="Notifications"
              icon="bell"
              hiddenlabel
              fit="small"
              click={() => navigate('/user-access')}
              style={{ color: '#003e62' }}
            />
            {pendingAccessCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  top: '-4px',
                  right: '-4px',
                  width: '18px',
                  height: '18px',
                  borderRadius: '999px',
                  background: '#FCDDE0',
                  color: '#7a1f2b',
                  fontSize: '10px',
                  fontWeight: 'bold',
                  lineHeight: '18px',
                  textAlign: 'center',
                  padding: 0,
                  pointerEvents: 'none',
                  boxSizing: 'border-box'
                }}
              >
                {pendingAccessCount > 99 ? '99+' : pendingAccessCount}
              </span>
            )}
          </div>
          )}

          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '30px',
              cursor: 'pointer'
            }}
            onClick={() => navigate('/profile')}
            role="button"
            aria-label="Open profile page"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') navigate('/profile');
            }}
            tabIndex={0}
          >
          <p
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                marginLeft: "10px",
                fontFamily: "MDS Headline",
              }}
            >
          <img src={Ionis} alt="Company Logo" style={logoStyles2} />
          </p>
            <HoverTip
                        title={
                          "View Profile"
                        }
                      >
           
          {graphData.name ? (
            <div style={{ display: "flex", alignItems: "center" }}>
              {graphData.photo ? (
                <img
                  src={graphData.photo}
                  alt="User Profile"
                  style={userPhotoStyles}
                />
              ) : (
                <McIcon icon="user-circle" size="large"></McIcon> // Fallback icon if photo is not available
              )}
              <McTab
                slot="tab"
                active={window.location.pathname === '/profile'}
                label={graphData.name}
                style={{ color: "#ffff" }}
              ></McTab>
            </div>
          ) : (
            <McTab
              slot="tab"
              label={accounts[0]?.name}
              icon="user-circle"
            ></McTab>
          )}
          </HoverTip>
          </div>
        </div>
       
        {/*<div style={{display:'flex',alignItems: 'center'}}><McTab label="Srishti Singh"  icon="user-circle"></McTab></div>*/}
      </div>

{ 
profileStatus === 'succeeded' &&
!myprofiledata?.function   && <McNotification
  body="Please complete your Profile Details"
  appearance="info"
  closable={true}
  >
  <span style={{ marginLeft: '8px' }}>
    <a href="/profile" style={{ textDecoration: 'underline', fontWeight: 'bold', fontSize: '14px', fontStyle: 'italic' }}>Click here</a>
  </span>
</McNotification>}
    </div>
  );
};

export default Header;
